import React, { useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { BrandContext } from '../../contexts/brand-context';
import { UserContext } from '../../contexts/user-context';
import { FormatPhoneInput } from '../../services/utilities';
import apiTools from '../../services/api-tools';


const DocRequestForm = ({ address, propertyType, owner, parcelId, requestType, county, legalDescription, subdivision, state }) => {
    const { selectedBrand } = useContext(BrandContext);
    const { pcUser } = useContext(UserContext);
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [emailSent, setEmailSent] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [phoneInputValue, setPhoneInputValue] = useState("");

    const handlePhoneInput = (e) => {
        const formattedPhoneNumber = FormatPhoneInput(e.target.value);
        setPhoneInputValue(formattedPhoneNumber);
    };

    const onSubmit = data => {
        const docRequestObject = {
            name: pcUser.firstName + ' ' + pcUser.lastName,
            email: pcUser.email,
            phone: data.phone,
            maps: data.maps,
            ccrs: data.ccrs,
            brand: selectedBrand,
            notes: data.notes,
            address,
            propertyType,
            owner, 
            parcelId,
            requestType,
            county,
            legalDescription,
            subdivision,
            state
        }
        const sendEmail = async () => {
            await apiTools.post(`/email-doc-request`, docRequestObject).then((response) => setEmailSent(true));
        }
        sendEmail();
        setEmailSent(true);
    }
return (
    <>  {!showForm && <p>Click here to have Customer Service locate the documents and email them to you directly. <button className="btn btn-primary my-3" onClick={() => setShowForm(true)}>Request {requestType}</button></p>}
        {showForm && <><p className="fw-bold">{requestType} Request:</p>
            {emailSent ? <p>Thank you, your request has been sent. </p> :
            <form onSubmit={handleSubmit(onSubmit)}>
                    {parcelId && <div className="row pt-1">
                        <div className="col-3 col-sm-4 form-label fw-bold">
                            <label htmlFor="name">Parcel ID:</label>
                        </div>
                        <div className="col-9 col-sm-8 no-localization">
                            {parcelId}
                        </div>
                    </div>}
                    {address && <div className="row pt-1">
                        <div className="col-3 col-sm-4 form-label fw-bold">
                            <label htmlFor="name">Property Address:</label>
                        </div>
                        <div className="col-9 col-sm-8 no-localization">
                            {address}
                        </div>
                    </div>}
                {subdivision && <div className="row pt-1">
                    <div className="col-3 col-sm-4 form-label fw-bold">
                        <label htmlFor="name">Subdivision:</label>
                    </div>
                    <div className="col-9 col-sm-8 no-localization">
                        {subdivision}
                    </div>
                </div>}
                    {propertyType && <div className="row pt-1">
                        <div className="col-3 col-sm-4 form-label fw-bold">
                            <label htmlFor="name">Property Type:</label>
                        </div>
                        <div className="col-9 col-sm-8 no-localization">
                            {propertyType}
                        </div>
                    </div>}
                    {owner && <div className="row pt-1">
                        <div className="col-3 col-sm-4 form-label fw-bold">
                            <label htmlFor="name">Owner:</label>
                        </div>
                        <div className="col-9 col-sm-8 no-localization">
                            {owner}
                        </div>
                    </div>}
                <div className="row pt-1">
                    <div className="col-3 col-sm-4 form-label fw-bold">
                        <label htmlFor="name">Your Name:</label>
                    </div>
                    <div className="col-9 col-sm-8 no-localization">
                        {pcUser.firstName + " " + pcUser.lastName}
                    </div>
                </div>
                <div className="row pt-1">
                    <div className="col-3 col-sm-4 form-label fw-bold">
                        <label htmlFor="name">Your Email:</label>
                    </div>
                    <div className="col-9 col-sm-8 text-break no-localization">
                        {pcUser.email}
                    </div>
                </div>
                <div className="row pt-1">
                    <div className="col-3 col-sm-4 form-label fw-bold required">
                        <label htmlFor="phone">Phone:</label>
                    </div>
                    <div className="col-9 col-sm-4">
                        <input autoComplete="tel" name="phone" type="tel" id="phone" className="form-control" {...register("phone", { required: true, minLength: 12 })} onChange={(e) => handlePhoneInput(e)} value={phoneInputValue} />
                        {errors?.phone?.type === "required" && <small className="text-danger">This field is required</small>}
                        {errors?.phone?.type === "minLength" && <small className="text-danger">Please enter a valid phone number.</small>}
                    </div>
                </div>
                {requestType === "CC&Rs" && <><div className="row pt-1">
                    <div className="col-3 col-sm-4 form-label fw-bold">
                        <label htmlFor="maps" >Request Maps?</label>
                    </div>
                    <div className="col-9 col-sm-4">
                        <input id="maps" defaultChecked={true} type="checkbox" name="maps" {...register("maps")} />
                    </div>
                </div>
                    <div className="row pt-1">
                        <div className="col-3 col-sm-4 form-label fw-bold">
                            <label htmlFor="ccrs" >Request CC&Rs?</label>
                        </div>
                        <div className="col-9 col-sm-4">
                            <input id="ccrs" defaultChecked={true} type="checkbox" name="ccrs" {...register("ccrs")} />
                        </div>
                    </div></>}
                <div className="row pt-1">
                    <div className="col-3 col-sm-4 form-label fw-bold">
                        <label htmlFor="notes" >Notes or Special Requests:</label>
                    </div>
                    <div className="col-9 col-sm-4">
                        <textarea name="notes" rows="2" cols="20" id="notes" className="form-control" {...register("notes")}></textarea>
                    </div>
                </div>
                <div className="row pt-1">
                    <div className="d-none d-sm-block col-sm-4"></div>
                    <div className="col col-sm-4 d-flex">
                        <input type="submit" name="submitQuoteRequest" value="Submit" id="submitQuoteRequest" className="btn btn-primary mx-auto" />
                    </div>
                </div>
            </form>}
        </>}
    </>
    );
}

export default DocRequestForm;